import {
  Grid, Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  Button,
} from "@mui/material";
import { useNavigate } from "react-router";
import { PersonAddAlt } from "@mui/icons-material";
import ListSocio from "pages/socio/ListSocio";
import AccountsModal from "pages/account/AccountsModal";

export default function Socio() {
  const [objSocio, setObjSocio] = useState({});
  const [IsAccountsModalOpen, setIsAccountsModalOpen] = useState(false);
  const navigate = useNavigate();

  const onSocioClick = (socioData) => {
    setObjSocio(socioData)
    setIsAccountsModalOpen(true);
  };

  const handleClose = () => {
    setIsAccountsModalOpen(false);
  };

  return (
    <>
      <Grid container>
        <Grid item xs={8} md={6}>
          <Typography variant="h2">
            Socios Cuenta
          </Typography>
        </Grid>
        <Grid item xs={4} md={6} textAlign="right">
          <Button
            size="large"
            variant="contained"
            onClick={() => navigate("/home/socio/new")}
            startIcon={<PersonAddAlt />}
          >
            Nuevo Socio
          </Button>
        </Grid>
        <Grid item xs={12}>
          <ListSocio
            onSocioClick={onSocioClick}
          />
        </Grid>
      </Grid>
      <AccountsModal
        open={IsAccountsModalOpen}
        codigoSocio={objSocio.codigo}
        onClose={handleClose}
      />
    </>
  );
}
